<template>
  <q-dialog v-model="setDefaultMarketValueDialog.show" persistent transition-show="scale" transition-hide="scale">
    <q-card>
      <q-form @submit="onSubmit" ref="setDefaultMarketValueDialogForm" class="flexbox" style="max-width: 300px;">
        <div class="q-pa-md">
          <div class="row q-col-gutter-xs flex-center">
            <h6 class="col-md-12 q-mt-auto q-mb-auto flex-center">Set default market value</h6>
            <span class="q-mb-sm" v-text="setDefaultMarketValueDialog.vin"></span>
            <div class="col-md-12">
              <q-input outlined
                       autofocus
                       clearable
                       type="text"
                       ref="value"
                       label="Market value"
                       placeholder="Example: 25300, 32800.33"
                       stack-label color="grey-7"
                       label-color="grey-7"
                       v-model="value"></q-input>
            </div>
            <div class="mt-5 flex-center q-gutter-xs" style="margin-top: 10px">
              <q-btn v-bind:disabled="loading" style="margin-right: 10px" color="grey-7" label="Close"
                     @click="close()"></q-btn>
              <q-btn :loading="loading" label="Save" type="submit" color="positive">
                <template v-slot:loading>
                  <q-spinner-facebook/>
                </template>
              </q-btn>
            </div>
          </div>
        </div>
      </q-form>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from "@/axios";

export default {
  name: 'VehicleDefaultMarketValueDialog',
  data() {
    return {
      loading: false,
      value: null,
    }
  },
  computed: {
    setDefaultMarketValueDialog: {
      get() {
        return this.$store.state.vehicle.setDefaultMarketValueDialog
      },
      set(val) {
        this.$store.commit('vehicle/SET_DEFAULT_MARKET_VALUE_DIALOG', val)
      }
    },
  },
  methods: {
    close() {
      this.loading = false;
      this.$store.commit('vehicle/SET_DEFAULT_MARKET_VALUE_DIALOG', {
        show: false,
        id: null,
        vin: null,
        currentValue: null,
      });
    },
    async onSubmit() {
      this.loading = true;

      try {
        const {data} = await axios.patch(`vehicle/set-default-market-value/${this.setDefaultMarketValueDialog.id}`, {
          value: this.value,
        });

        this.$q.notify({
          message: data.message,
          timeout: 1000,
          position: "top-right",
          progress: true,
          type: "positive",
        });

        this.$store.commit('profit/SET_DEFAULT_MARKET_VALUE_UPDATED', this.setDefaultMarketValueDialog.id);
        this.close();
      } catch (e) {
        let message = 'There was a problem, please try again!';

        if (e.response.status === 422) {
          message = 'This value must be a number only!';
        }

        this.$q.notify({
          message,
          timeout: 1000,
          position: "top-right",
          progress: true,
          type: "negative",
        });

        this.$refs.value.$el.focus();
      } finally {
        this.loading = false;
      }
    }
  },
  watch: {
    setDefaultMarketValueDialog: {
      deep: true,
      handler() {
        this.value = this.setDefaultMarketValueDialog.currentValue;
      }
    }
  }
}
</script>
